import { Suspense, type ReactNode } from 'react';
import { PageLoader } from '@/components/feedback/PageLoader';

interface SuspenseBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function SuspenseBoundary({ children, fallback = <PageLoader /> }: SuspenseBoundaryProps) {
  return <Suspense fallback={fallback}>{children}</Suspense>;
}
